import {useSportContext} from '@/context/SportContext';
import {memo, useEffect} from 'react';
import {Outlet} from 'react-router-dom';

export const TocaSportWrapper = memo(() => {
  const {sport, setSport} = useSportContext();

  useEffect(() => {
    if (!sport) {
      setSport({sport: 'TOCA'});
    }
  }, [setSport, sport]);

  return sport ? <Outlet /> : null;
});

TocaSportWrapper.displayName = 'TocaSportWrapper';
